module.exports = __webpack_public_path__ + "img/2_2-commerciale-stadio-1.ca885299.png";